<template>
    <div id="confirmChangeDialog">
      <v-dialog v-model="showDialog" @keydown.esc="cancel" persistent max-width="700">
        <v-card>
          <div>
            <v-card-title class="modal-headline" id="dialogTitle">{{messages.confirmChangeHeader}}
              <v-spacer></v-spacer>
              <v-btn :ripple="false" icon ref="dialogHeaderCloseBtn" text @click.stop="cancel" @keydown="dialogHeaderCloseKeydown($event)" aria-label="Close">
                <v-icon color="white">close</v-icon>
              </v-btn>
            </v-card-title>
          </div>
          <v-card-text class="pt-4">{{ messages.confirmChangeMessage }} </v-card-text>
          <v-card-text>
            <div class="dialog-row" v-if="changedDetails.firstName">
              <div class="dialog-label">{{messages.confirmChangeFirstName}}</div>
              <div class="dialog-new">{{changedDetails.firstName.new}}</div>
              <div class="dialog-old">({{messages.confirmPrevious}} '{{changedDetails.firstName.old}}')</div>
            </div>
            <div class="dialog-row" v-if="changedDetails.lastName">
              <div class="dialog-label">{{messages.confirmChangeLastName}}</div>
              <div class="dialog-new">{{changedDetails.lastName.new}}</div>
              <div class="dialog-old">({{messages.confirmPrevious}} '{{changedDetails.lastName.old}}')</div>
            </div>
            <div class="dialog-row" v-if="changedDetails.email">
              <div class="dialog-label">{{messages.confirmChangeEmail}}</div>
              <div class="dialog-new">{{changedDetails.email.new}}</div>
              <div class="dialog-old">({{messages.confirmPrevious}} '{{changedDetails.email.old}}')</div>
            </div>
            <div class="dialog-row" v-if="changedDetails.phone">
              <div class="dialog-label">{{messages.confirmChangePhone}}</div>
              <div class="dialog-new">{{changedDetails.phone.new}}</div>
              <div class="dialog-old">({{messages.confirmPrevious}} '{{changedDetails.phone.old}}')</div>
            </div>
            <div class="dialog-row" v-if="changedDetails.dateOfBirth">
              <div class="dialog-label">{{messages.confirmChangeDOB}}</div>
              <div class="dialog-new">{{changedDetails.dateOfBirth.new | formatDate(selectedLanguage) }}</div>
              <div class="dialog-old">({{messages.confirmPrevious}} '{{changedDetails.dateOfBirth.old}}')</div>
            </div>
          <div style="clear:both;"></div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="modal-confirm-button"
              text @click.stop="overwrite"
              v-if="dialogButtonOverwrite"
              ref="dialogButtonOverwriteRef">{{ messages.confirmChangeOverwrite }}
            </v-btn>
             <!--<v-btn
              class="modal-confirm-button"
              text @click.stop="donotoverwrite">{{ messages.confirmChangeDoNotOverwrite }}
            </v-btn>-->
            <v-btn
               class="modal-confirm-button"
              text @click.stop="cancel"
              ref="dialogButtonClose"
              @keydown="dialogButtonCloseKeydown($event)">{{ messages.confirmChangeCancel }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>

import { mapState } from 'vuex'

export default {

  data: () => ({
    id: '',
    dialogButtonOverwrite: true
  }),
  props: [
    'showDialog',
    'changedDetails'
  ],
  computed: {
    ...mapState([
      'configuration',
      'messages',
      'funcDebug',
      'selectedLanguage'
    ])
  },
  watch: {
    changedDetails (newValue) {
      this.changedDetails = newValue
    },
    deep: true,
    showDialog () {
      this.$nextTick(() => {
        if (this.showDialog) {
          this.$nextTick(() => {
            this.$refs.dialogHeaderCloseBtn.$el.focus()
          })
        }
      })
    }

  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    overwrite () {
      this.$emit('overwrite')
    },
    donotoverwrite () {
      this.$emit('donotoverwrite')
    },
    dialogHeaderCloseKeydown (event) {
      if (event.shiftKey && event.keyCode === 9) {
        event.preventDefault()
        this.$refs.dialogButtonClose.$el.focus()
      }
    },
    dialogButtonCloseKeydown (event) {
      if (event.shiftKey && event.keyCode === 9) {
        event.preventDefault()
        if (this.dialogButtonOverwrite) {
          this.$refs.dialogButtonOverwriteRef.$el.focus()
        } else {
          this.$refs.dialogHeaderCloseBtn.$el.focus()
        }
      } else if (event.keyCode === 9) {
        event.preventDefault()
        this.$refs.dialogHeaderCloseBtn.$el.focus()
      }
    }
  }
}
</script>
<style lang="scss">
.modal-confirm-button {
  background-color: var(--primary-btn-bg-color) !important;
  color: var(--primary-btn-text-color) !important;
}
.modal-headline{
  background-color: var(--primary-color) !important;
  color: var(--primary-bg-text-color) !important;
}

.dialog-row {
  width: 100%;
  float: left;

}
.dialog-label {
  width: 20%;
  float: left;

}
.dialog-new {

  float: left;
  font-weight: bold;
}
.dialog-old{

  font-style: italic;
    float: left;
    margin-left: 3px;
}

@media only screen and (min-width: 768px){
 .normal-hidden{
    display: none;
  }
}

@media only screen and (max-width: 760px) {
  .small-hidden{
    display: none;
  }

  .small-underlined{
    font-weight: bold;
  }

  .dialog-info, .dialog-info1, .dialog-label, .dialog-label1 {
    width: 100%;
  }

}
</style>
